import * as React from 'react'

// Components
import Svg from './..'

const LightBulb = (props) => {
  return (
    <Svg fill="none" viewBox="0 0 26 26" {...props}>
      <path
        d="M13 5.91A7.09 7.09 0 0120.09 13a7.107 7.107 0 01-3.545 6.146v2.127a1.182 1.182 0 01-1.181 1.181h-4.728a1.182 1.182 0 01-1.181-1.181v-2.127A7.107 7.107 0 015.909 13 7.091 7.091 0 0113 5.91zm2.364 17.726v1.182A1.182 1.182 0 0114.182 26h-2.364a1.182 1.182 0 01-1.182-1.182v-1.182zm7.09-11.818H26v2.364h-3.546zM0 11.818h3.545v2.364H0zM14.182 0v3.545h-2.364V0zm-9.55 2.955L7.15 5.484 5.472 7.15 2.955 4.645zM18.85 5.472l2.506-2.517 1.69 1.69-2.518 2.505z"
        fill="#98979c"
      />
    </Svg>
  )
}

export default LightBulb
